import React, { useState, useEffect, useContext } from 'react';
import {
  Grid, Hidden, IconButton, Menu, MenuItem, LinearProgress, useMediaQuery,
} from '@material-ui/core';
import {
  GridToolbarContainer, GridToolbarColumnsButton, GridToolbarDensitySelector, GridToolbarFilterButton,
} from '@material-ui/data-grid';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  EditOutlined as EditarIcon,
  ListOutlined as MenuIcon,
} from '@material-ui/icons';
import { useHistory } from 'react-router-dom';
import { useRoles } from '@hooks';
import { Alert, DataGrid } from '@components/atoms';

import AuthContext from '@contexts/AuthContext';
import i18n from '@i18n';

const List = () => {
  const { pages: { employees: { roles: { list: texts } } } } = i18n;
  const history = useHistory();
  const classes = useStyles();
  const { getRoles, rolesError, isRolesLoading } = useRoles();
  const [roles, setRoles] = useState([]);
  const [actionSelected, setActionSelected] = useState(null);
  const { user } = useContext(AuthContext);
  const theme = useTheme();

  const ltSmSize = useMediaQuery(theme.breakpoints.down('sm'));
  const onlyxsSize = useMediaQuery(theme.breakpoints.only('xs'));

  useEffect(async () => {
    setRoles(await getRoles());
  }, []);
  const handleClose = () => {
    setActionSelected(null);
  };

  const CustomToolbar = () => (
    <>
      <Hidden xsDown>
        <GridToolbarContainer>
          <GridToolbarColumnsButton />
          <GridToolbarDensitySelector />
          <GridToolbarFilterButton />
        </GridToolbarContainer>
      </Hidden>
      <Hidden smUp>
        <GridToolbarContainer>
          <GridToolbarColumnsButton />
          <GridToolbarFilterButton />
        </GridToolbarContainer>
      </Hidden>
    </>
  );

  const menuActions = (values) => (
    <>
      <Hidden xsDown>
        { user && user.permissions.presupuesto.update && (
        <IconButton className={classes.actionIcons} onClick={() => history.push(`/e/roles/edit/${values.row.id}`)}>
          <EditarIcon />
        </IconButton>
        )}
        {/* {user && user.permissions.presupuesto.read && (
        <IconButton className={classes.actionIcons} onClick={() => history.push(`/e/rol/view/${values.row.id}`)}>
          <VerIcon />
        </IconButton>
        )} */}
      </Hidden>
      <Hidden smUp>
        <IconButton
          className={classes.actionIcons}
          onClick={(event) => setActionSelected({ anchorEl: event.currentTarget, id: values.row.id })}
        >
          <MenuIcon />
        </IconButton>
        <Menu
          anchorEl={actionSelected && actionSelected.anchorEl}
                /* eslint-disable react/destructuring-assignment */
          open={actionSelected && actionSelected.id === values.row.id}
          onClose={handleClose}
        >
          {user && user.permissions.presupuesto.update && (
          <MenuItem onClick={() => history.push(`/e/roles/edit/${values.row.id}`)}>Editar</MenuItem>
          )}
          {/* {user && user.permissions.presupuesto.read && (
          <MenuItem onClick={() => history.push(`/e/presupuestos/view/${values.row.id}`)}>Ver</MenuItem>
          )} */}
        </Menu>
      </Hidden>
    </>
  );

  const columnsSm = [
    {
      field: 'id',
      headerName: texts.columns.customer,
      hide: true,
    },
    {
      field: 'name',
      headerAlign: 'center',
      headerName: texts.columns.name,
      align: 'center',
    },
    {
      field: 'actions',
      headerName: 'Acciones',
      headerAlign: 'center',
      align: 'center',
      renderCell: (values) => (menuActions(values)),
    },
  ];

  const columns = [
    {
      field: 'id',
      headerName: texts.columns.customer,
      flex: 0.5,
      hide: true,
    },
    {
      field: 'name',
      headerAlign: 'center',
      headerName: texts.columns.name,
      align: 'left',
      flex: 0.4,
    },
    {
      field: 'actions',
      headerName: 'Acciones',
      flex: 0.5,
      headerAlign: 'center',
      align: 'center',
      renderCell: (values) => (menuActions(values)),
    },
  ];

  return (
    <>
      {rolesError && <Alert>{rolesError.message}</Alert>}
      {(isRolesLoading) && <LinearProgress />}
      {roles && roles.length > 0 && (
        <Grid container spacing={2}>
          <DataGrid
            sortModel={[{ field: 'name', sort: 'desc' }]}
            columns={onlyxsSize ? columnsSm : columns}
            rows={roles}
            pageSize={ltSmSize ? 8 : 25}
            components={{
              Toolbar: CustomToolbar,
            }}
          />
        </Grid>
      )}
    </>
  );
};

const useStyles = makeStyles({
  actionIcons: {
    padding: '4px',
  },
});

export default List;
